import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state () {
    return {
      collectionType: localStorage.collectionType ? localStorage.collectionType : "1",
      viewImg: '',
    }
  },
  getters: {
  },
  mutations: {
    collectionTypeChange (state, val) {
      state.collectionType = val;
      localStorage.setItem('collectionType', val);
    },
    viewImgChange(state, srcxx){
      state.viewImg = srcxx ? srcxx : ''
    }
  },
  actions: {
  },
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js